// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1UraY","col":"Table_col__2iZTg","fulfillmentStatus":"Table_fulfillmentStatus__1O_Oi","emailCol":"Table_emailCol__2AlQs"};